import { ApiService } from '../../../services/api_service';
import { ContextService } from '../../../services/context_service';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Statistik } from './Statistik';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

interface StatistikTabsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface StatistikTabsState {
    tabIndex: number;
    statistik: any;
}

export class StatistikTabs extends React.Component<StatistikTabsProps, StatistikTabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null,
            statistik: {}
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private disabled: string[] = [];
    private prefix: string = 'admin.tab';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_STATISTIK;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_STATISTIK_HANDWERK },
        { path: RoutingIDs.ROUTE_STATISTIK_KULTUR },
        { path: RoutingIDs.ROUTE_STATISTIK_SONSTIGE },
        { path: RoutingIDs.ROUTE_STATISTIK_SYSTEM }
    ];
    private tabs: string[] = ['statistik', 'statistik', 'statistik', 'statistik']; // Reitereihenfolge beachten

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
        this.loadData();
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    loadData(): void {
        const bereich = ['handwerk', 'kultur', 'sonstige'];
        bereich.forEach((bereich_key: string) => {
            this.apiService.call('getStatistik', { bereich_key }, (json: string, succ: boolean) => {
                if (succ) {
                    let data;
                    try {
                        data = JSON.parse(json);
                    } catch (e) {
                        console.error(e, json);
                    }
                    console.log(bereich_key, data);
                    if (data) {
                        const { statistik } = this.state;
                        statistik[bereich_key] = data;
                        this.setState({ statistik });
                    }
                }
            }, IDs.MOD_ETOOL);
        });
    }

    render(): JSX.Element {
        const { statistik } = this.state;

        if (this.state.tabIndex === null) {
            return null;
        }

        if (!statistik.handwerk || !statistik.kultur || !statistik.sonstige) {
            return <WSpinner />;
        }

        return (
            <Tabs
                className='tabs-admin-statistik'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.statistik}>Handwerk</Tab>
                    <Tab disabled={!this.rechte.statistik}>Kultur</Tab>
                    <Tab disabled={!this.rechte.statistik}>Sonstige</Tab>
                    {/* <Tab disabled={!this.rechte.statistik}>System</Tab> */}
                    {this.renderReloadBtn()}
                </TabList>
                <TabPanel>
                    {this.rechte.statistik &&
                        <Statistik
                            data={this.props.data}
                            tabKey='handwerk'
                            statistik={this.state.statistik}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.statistik &&
                        <Statistik
                            data={this.props.data}
                            tabKey='kultur'
                            statistik={this.state.statistik}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.statistik &&
                        <Statistik
                            data={this.props.data}
                            tabKey='sonstige'
                            statistik={this.state.statistik}
                        />
                    }
                </TabPanel>
                {/* <TabPanel>
                    {this.rechte.statistik &&
                        <Statistik
                            data={this.props.data}
                            tabKey='system'
                            statistik={this.state.statistik}
                        />
                    }
                </TabPanel> */}
                <TabPanel />
            </Tabs>
        );
    }

    renderReloadBtn(): JSX.Element {
        return <Tab
            style={{
                color: 'white', border: 0, borderColor: '#6692c3', borderTop: '1px solid', borderRadius: 0, backgroundColor: '#6692c3',
                marginTop: 11, paddingRight: 21, paddingLeft: 21, display: 'unset', float: 'right', cursor: 'pointer'
            }}
            onClick={() => this.setState({ statistik: {} }, this.loadData)}
            disabled
        >
            Daten neu laden
        </Tab>;
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
